<div class="fullPageMainContent">
  <google-map class="mapClass" [hidden]="!mapOk"
              height="100%"
              width="100%"
              [options]="options"

              (tilesloaded)="tryFitBoundsToMarkers()">
      <map-marker class="borderlessPopup"
        #markerElem="mapMarker"
        [options]="marker.options"
        *ngFor="let marker of pointers"
        [position]="marker.position"
        (mapClick)="openInfo(marker, markerElem)">
        <map-info-window  *ngIf="!!selectedPointer">
          <div class="simpleFlexContent markerInfoWindowTitle" *ngIf="!!selectedPointer">
            <span><h3 style="margin: 0 5px;; max-width: 190px; text-align: center"><b>{{selectedPointer.name}}</b></h3></span>
          </div>
          <mat-divider></mat-divider>

          <div class="simpleFlexContent markerInfoWindow" *ngIf="!!selectedPointer">
            <span style="margin: 0 3px;"><b>{{selectedPointer.label}}</b></span>
            <img style="max-width: 120px; margin-top: 10px" [src]="!!selectedPointer.imageUrl? selectedPointer.imageUrl : 'assets/logo.png'"/>
          </div>
          <mat-divider  *ngIf="selectedPointer.hasDae"></mat-divider>
          <div  *ngIf="!!selectedPointer && selectedPointer.hasDae" class="simpleHorizFlexContent markerInfoWindow">
            <img style="max-width: 120px;" [src]="'assets/daeLogo.png'"/>
          </div>
        </map-info-window>
      </map-marker>
  </google-map>
</div>
